// Field + table configuration for each CMS resource, driving the generic manager.
export const RESOURCE_CONFIG = {
  blog: {
    title: "Blog Posts",
    singular: "Post",
    columns: [
      { key: "title", label: "Title" },
      { key: "category", label: "Category" },
      { key: "author", label: "Author" },
      { key: "published", label: "Published", type: "boolean" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "author", label: "Author", type: "text" },
      { name: "read_time", label: "Read time (min)", type: "number" },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "cover_image", label: "Cover image URL", type: "text", full: true },
      { name: "content", label: "Content", type: "textarea", full: true, rows: 8 },
      { name: "tags", label: "Tags (comma separated)", type: "list" },
      { name: "published", label: "Published", type: "boolean" },
    ],
  },
  portfolio: {
    title: "Portfolio",
    singular: "Project",
    columns: [
      { key: "title", label: "Title" },
      { key: "category", label: "Category" },
      { key: "client", label: "Client" },
      { key: "featured", label: "Featured", type: "boolean" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "client", label: "Client", type: "text" },
      { name: "image", label: "Image URL", type: "text", full: true },
      { name: "description", label: "Description", type: "textarea", full: true },
      { name: "tags", label: "Tags (comma separated)", type: "list" },
      { name: "url", label: "Live URL", type: "text" },
      { name: "order", label: "Order", type: "number" },
      { name: "featured", label: "Featured", type: "boolean" },
    ],
  },
  services: {
    title: "Services",
    singular: "Service",
    columns: [
      { key: "title", label: "Title" },
      { key: "category", label: "Category" },
      { key: "order", label: "Order" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "icon", label: "Icon (lucide name)", type: "text" },
      { name: "short_desc", label: "Short description", type: "textarea" },
      { name: "description", label: "Full description", type: "textarea", full: true, rows: 5 },
      { name: "features", label: "Features (comma separated)", type: "list" },
      { name: "order", label: "Order", type: "number" },
    ],
  },
  testimonials: {
    title: "Testimonials",
    singular: "Testimonial",
    columns: [
      { key: "name", label: "Name" },
      { key: "company", label: "Company" },
      { key: "rating", label: "Rating" },
    ],
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "role", label: "Role", type: "text" },
      { name: "company", label: "Company", type: "text" },
      { name: "avatar", label: "Avatar URL", type: "text", full: true },
      { name: "quote", label: "Quote", type: "textarea", full: true },
      { name: "rating", label: "Rating (1-5)", type: "number" },
      { name: "order", label: "Order", type: "number" },
    ],
  },
  team: {
    title: "Team",
    singular: "Member",
    columns: [
      { key: "name", label: "Name" },
      { key: "role", label: "Role" },
      { key: "order", label: "Order" },
    ],
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "role", label: "Role", type: "text" },
      { name: "avatar", label: "Avatar URL", type: "text", full: true },
      { name: "bio", label: "Bio", type: "textarea", full: true },
      { name: "order", label: "Order", type: "number" },
    ],
  },
  careers: {
    title: "Careers",
    singular: "Job",
    columns: [
      { key: "title", label: "Title" },
      { key: "department", label: "Department" },
      { key: "location", label: "Location" },
      { key: "published", label: "Published", type: "boolean" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "department", label: "Department", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "type", label: "Type", type: "text" },
      { name: "description", label: "Description", type: "textarea", full: true, rows: 5 },
      { name: "requirements", label: "Requirements (comma separated)", type: "list" },
      { name: "published", label: "Published", type: "boolean" },
    ],
  },
  faqs: {
    title: "FAQs",
    singular: "FAQ",
    columns: [
      { key: "question", label: "Question" },
      { key: "category", label: "Category" },
      { key: "order", label: "Order" },
    ],
    fields: [
      { name: "question", label: "Question", type: "text" },
      { name: "answer", label: "Answer", type: "textarea", full: true },
      { name: "category", label: "Category", type: "text" },
      { name: "order", label: "Order", type: "number" },
    ],
  },
  pricing: {
    title: "Pricing Plans",
    singular: "Plan",
    columns: [
      { key: "name", label: "Name" },
      { key: "price", label: "Price" },
      { key: "period", label: "Period" },
      { key: "highlighted", label: "Highlighted", type: "boolean" },
    ],
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "price", label: "Price", type: "number" },
      { name: "period", label: "Period (project/custom)", type: "text" },
      { name: "description", label: "Description", type: "textarea", full: true },
      { name: "features", label: "Features (comma separated)", type: "list" },
      { name: "order", label: "Order", type: "number" },
      { name: "highlighted", label: "Highlighted", type: "boolean" },
    ],
  },
};
